import React, { memo, useState } from 'react';
import { Box } from '@mui/material';
import ThumbnailActions from './ThumbnailActions';
import { ThumbnailPreviewProps } from '../types';

const ThumbnailPreview = memo(({
	thumbnailUrl,
	onHover,
	onReplace,
	onDelete,
	onCrop
}: ThumbnailPreviewProps) =>
{
	const [ isHovering, setIsHovering ] = useState(false);

	const handleMouseEnter = () =>
	{
		setIsHovering(true);
		onHover(true);
	};

	const handleMouseLeave = () =>
	{
		setIsHovering(false);
		onHover(false);
	};

	return (
		<Box
			my={1}
			sx={{ width: '250px', height: '150px', position: 'relative', borderRadius: '13px', overflow: 'hidden' }}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<img
				src={thumbnailUrl}
				style={{ width: '100%', height: '100%', objectFit: 'cover', overflow: 'hidden', borderRadius: '13px' }}
				alt='Thumbnail'
			/>
			{isHovering && (
				<ThumbnailActions
					onHover={onHover}
					onReplace={onReplace}
					onDelete={onDelete}
					onCrop={onCrop}
				/>
			)}
		</Box>
	);
});

ThumbnailPreview.displayName = 'ThumbnailPreview';

export default ThumbnailPreview;